var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.tab
    }
  }, [_c('div', {
    staticClass: "human-resource-item--wrap"
  }, [_c('div', {
    staticClass: "mb-12 mb-lg-20"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('human-resource-search')], 1)], 1)], 1), _vm.applications.length ? [_c('div', _vm._l(_vm.applications, function (item) {
    return _c('human-resource-item', {
      key: item === null || item === void 0 ? void 0 : item._id,
      attrs: {
        "value": item,
        "recruitment": item.recruitment
      }
    });
  }), 1), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "grey-f7 rounded-lg pa-20 pa-md-30",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 찜한 지원서가 없습니다. ")]), _c('v-btn', {
    attrs: {
      "to": "/dashboard/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용공고 관리하기")])])], 1)]], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }